import { useQuery } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { DownloadStatsResponse, ApiError } from '../types/showcase';

/**
 * Query: GET /api/eraf/catalog/download-stats?top=5 (queue #662 §UAT-2026-07-09-R662 §R662-3).
 * 카탈로그 트리 배지 · 모듈 상세 다운로드 수 · _index '인기 모듈' 카드가 공유하는 단일
 * 쿼리키(['download-stats']) — TanStack Query 가 동시 소비자 간 요청을 dedupe 한다.
 * 부가 지표라 실패해도 카탈로그/대시보드 본체를 막지 않는다 — 호출부는 `isLoading`/
 * `isError`/`!data` 시 graceful 생략(fail-soft, §R662-3).
 */
export function useDownloadStats(top = 5) {
  return useQuery<DownloadStatsResponse, ApiError>({
    queryKey: ['download-stats'],
    queryFn: () => showcaseApi.downloadStats(top),
    retry: false,
    staleTime: 5 * 60_000,
  });
}
